import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../routes";

const ReportingIndexPage = () => {
  const navigate = useNavigate();

  const { pathname } = useLocation();

  // Cannot route to index page (throw on cardload page)
  useEffect(() => {
    if (pathname === ROUTES.REPORTS.INDEX) {
      navigate(ROUTES.REPORTS.CARD_LOAD);
    }
  }, []);

  return (
    <>
      <Outlet />
    </>
  );
};

export default ReportingIndexPage;
